import { gtmLoadInterval } from "@/src/helpers/google-tag-manager/gtm-load-interval";
import { GTMPushEvent } from "@/src/helpers/google-tag-manager";

export const sendVlProductDetailEvent = (params) => {
  const { title, id, price, cityName, districtName, townName, properties = [] } = params;
  const [roomCountProperty, buildingAgeProperty, propertyStatus] = [
    properties?.find((prop) => prop.key === "room_count"),
    properties?.find((prop) => prop.key === "build_age"),
    properties?.find((prop) => prop.key === "trade_type"),
  ];

  gtmLoadInterval(() => {
    GTMPushEvent({
      event: "vlEvent",
      vl_label: "VL-ProductDetailView",
      vl_ecommerce: {
        detail: {
          product: {
            name: title || undefined,
            id: id?.toString() || undefined,
            price: price || undefined,
            stock: "1",
            city: cityName || undefined,
            town: districtName || undefined,
            neighborhood: townName || undefined,
            property_status: propertyStatus?.value || undefined,
            oda_sayisi: roomCountProperty?.value || undefined,
            bina_yasi: buildingAgeProperty?.value || undefined,
          },
        },
      },
    });
  });
};
